module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "background": "white"
    }
  }, [_c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "width": "calc(100% - 24px)",
      "height": "100%",
      "background": "none",
      "padding-left": "24px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.launchername : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "30px"
    }
  }, [_c('table', {
    staticClass: "dt-launch"
  }, [_c('tr', {}, [_c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_version')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.version : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_verTag')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.versioncode : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_package')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-word-main"
  }, [_vm._v(_vm._s(_vm.config ? _vm.config.packagename : ''))])]), _vm._v(" "), _c('td')])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background": "none",
      "min-height": "10px",
      "display": "-webkit-flex"
    }
  }, [_c('div', {
    staticClass: "dt-word-title",
    staticStyle: {
      "display": "inline-block",
      "min-width": "70px"
    }
  }, [_vm._v("\n          launch" + _vm._s(_vm.$t('app_ss')) + "：\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dt-word-main",
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "background": "none",
      "margin": "0 24px 24px 0"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.config.launcherdesc))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.captures ? _vm.captures.length > 0 : false),
      expression: "captures? captures.length > 0 : false"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor  gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_screenShot')) + " ")]), _vm._v(" "), _c('div', _vm._l((_vm.captures), function(item) {
    return _c('img', {
      staticClass: "gBorder",
      staticStyle: {
        "width": "180px",
        "height": "320px",
        "margin": "24px 0 24px 24px",
        "border-radius": "4px"
      },
      attrs: {
        "onerror": "this.src='/static/img/df-h.png'",
        "src": _vm.imgFullUrl(item)
      }
    })
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.config.status === '2'),
      expression: "config.status === '2'"
    }],
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_hisVer')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadNew
    }
  }, [_vm._v(_vm._s(_vm.$t('app_ulNew')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "launchername",
      "label": 'launcher' + _vm.$t('app_name'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "version",
      "width": "",
      "label": _vm.$t('app_version')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "fformatter": "dateFormat",
      "prop": "uploadtime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "",
      "width": "80",
      "label": _vm.$t('app_operate')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": _vm.$t('app_del'),
            "placement": "top"
          }
        }, [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.config.isoperate === 0),
            expression: "config.isoperate === 0"
          }],
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              _vm.delHis(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash-o",
          staticStyle: {
            "color": "#FF4949"
          }
        })])], 1)]
      }
    }])
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38264d8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/launch/detail.vue
// module id = 1012
// module chunks = 0